// import _ from 'lodash';
import debug from '../../services/debug';
import {
  SET_DOCUMENTS_REDIRECTROUTE_REQUESTED,
  // SET_CONTACT_REDIRECT_ABORTED,
  SET_DOCUMENTS_REDIRECTROUTE_COMPLETED,
  SET_DOCUMENTS_REDIRECTROUTE_FAILED,
} from './types';

const setDocumentsRedirectRoute = async () => async (dispatch) => {
  dispatch({
    type: SET_DOCUMENTS_REDIRECTROUTE_REQUESTED,
  });

  try {
    dispatch({
      type: SET_DOCUMENTS_REDIRECTROUTE_COMPLETED,
    });
  } catch (err) {
    debug(SET_DOCUMENTS_REDIRECTROUTE_FAILED, err);

    dispatch({
      type: SET_DOCUMENTS_REDIRECTROUTE_FAILED,
      payload: err,
    });
  }
};

export default setDocumentsRedirectRoute;
